import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    standalone: true,
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {
    brand = {
        name: 'Code Clairvoyance',
        tagline: 'Code-processing tool for professionals',
    };
    currentYear = new Date().getFullYear();
}